export const Socialdata=[
    
    {
        platform:"Github",
        details:"adityapathak-auto",
        
        link:"https://github.com/adityapathak-auto",
        icon:require("../body/assets/icons/github.gif")
    },
    {
        platform:"Linkedin",
        details:"aditya-pathak-auto",
        link:"https://www.linkedin.com/in/aditya-pathak-auto/",
        icon:require("../body/assets/icons/linkedin.gif")
    },
    {
        platform:"WhatsApp",
        details:"+91 8602116351",
        link:"https://api.whatsapp.com/send/?phone=+918602116351&text&app_absent=0",
        icon:require("../body/assets/icons/whatsapp.gif")
    },
    {
        platform:"WhatsApp",
        details:"manhit06@gmail.com",
        link:"mailto:manhit06@gmail.com",
        icon:require("../body/assets/icons/gmail.gif")
    },
    {
        platform:"Facebook",
        details:"adityapathak1697",
        link:"https://www.facebook.com/adityapathak1697/",
        icon:require("../body/assets/icons/facebook.gif")
    },
    {
        platform:"insta",
        details:"adityapathak166",
        link:"https://www.instagram.com/adityapathak166/",
        icon:require("../body/assets/icons/instagram.gif")
    },

]